import React from "react";
import './RoundObjects.css';

export const IconCircle = props =>
  <span className="skill-icon rounded-circle mx-auto mb-3 text-center">
    {props.children}
  </span>;